import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraPageHeader, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { RfiFollowUpsPanel } from '../RfiFollowUpsPanel';
import { RfiSourceVersionsPanel } from '../RfiSourceVersionsPanel';
import { useRfiPeople, useRfiSections } from '../rfiSectionHooks';
import { useRfiRecord } from './RfiRecordContext';
/**
 * Q&A and amendments (WRT-07 page 6): questions to the agency (the existing
 * follow-ups panel) and the source version history (amendments are the
 * versions after the first).
 */ export function RfiQaAmendmentsPage() {
    const record = useRfiRecord();
    const rfiId = record?.pangaeaId ?? '';
    const { data: sections = [] } = useRfiSections(rfiId);
    const { data: people = [] } = useRfiPeople();
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-[var(--space-6)] p-[var(--space-6)]",
        "data-testid": Testids.rfiWorkspace.qaPage,
        children: [
            /*#__PURE__*/ _jsx(SpecraPageHeader, {
                title: "Q&A and amendments",
                titleSize: "ui"
            }),
            rfiId ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("section", {
                        className: "flex flex-col gap-[var(--space-2)]",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                                title: "Questions to the agency",
                                variant: "group"
                            }),
                            /*#__PURE__*/ _jsx(RfiFollowUpsPanel, {
                                people: people,
                                rfiResponseProjectId: rfiId,
                                sections: sections
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("section", {
                        className: "flex flex-col gap-[var(--space-2)]",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                                title: "Amendments",
                                variant: "group"
                            }),
                            /*#__PURE__*/ _jsx(RfiSourceVersionsPanel, {
                                rfiResponseProjectId: rfiId
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
}
